"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../../ThemeProvider");
var _Title = require("../../Elements/Title/Title");
var _Text = require("../../Elements/Text/Text");
var _Button = require("../../Elements/Button/Button");
var _Card = _interopRequireDefault(require("../Card/Card"));
var _Image = _interopRequireDefault(require("../Image/Image"));
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
  /**
   * @d.aefault 'simple-card'
  */
  bsPrefix: _propTypes.default.string,
  /**
   * Sets the image for the Simple card.
  */
  image: _propTypes.default.string,
  /**
   * Sets the title for the Simple card.
  */
  title: _propTypes.default.string,
  /**
   * Sets the title size for the Simple card.
  */
  titleSize: _propTypes.default.string,
  /**
   * Sets the title tag type for the Simple card.
  */
  titleTag: _propTypes.default.string,
  /**
   * Sets the body text for the Simple card.
  */
  bodyText: _propTypes.default.string,
  /**
     * Sets the button props for the Simple card button.
  */
  /*button: PropTypes.shape({
      link: PropTypes.string,
      variant: PropTypes.string,
      useCallback: PropTypes.bool,
      text: PropTypes.string,
      icon: PropTypes.string,
      name: PropTypes.string,
      action: PropTypes.string,
      key: PropTypes.string,
      disabled: PropTypes.bool,
      iconPosition: PropTypes.string,
      onClick: PropTypes.func
  }),*/
  /**
   * Sets the class name for the Simple card.
  */
  className: _propTypes.default.string
};
const defaultProps = {
  button: {
    variant: 'brand-primary',
    size: 'large',
    disabled: false,
    icon: '',
    iconPosition: 'trailing',
    useCallback: false,
    link: '',
    name: '',
    action: '',
    handleCallback: () => {},
    onClick: () => {},
    text: '',
    analytics: ''
  }
};
const SimpleCard = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    bsPrefix,
    image,
    title,
    titleSize,
    titleTag,
    bodyText,
    button,
    className
  } = props;
  const prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'simple-card');
  const wrapperClassName = `${prefix} ${className}`;
  const card = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.default, {
    className: wrapperClassName,
    ref: ref,
    children: [image && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
      src: image,
      className: `${prefix}__card_image`
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.default.Body, {
      children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
        className: `${prefix}__card_title`,
        size: titleSize,
        tag: titleTag,
        content: title
      }), bodyText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
        type: "body-text",
        className: `${prefix}__card_body`,
        content: bodyText
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        link: button.link,
        icon: button.icon,
        useCallback: button.useCallback,
        text: button.text,
        variant: button.variant,
        name: button.name,
        action: button.action,
        handleCallback: button.onClick,
        disabled: button.disabled,
        iconPosition: button.iconPosition,
        className: `${prefix}__card_button`,
        "data-analytics": button.analytics
      }, button.name)]
    })]
  });
  return card;
});
SimpleCard.displayName = 'SimpleCard';
SimpleCard.defaultProps = defaultProps;
SimpleCard.propTypes = propTypes;
var _default = exports.default = SimpleCard;
module.exports = exports.default;